import * as React from 'react';
import { Group, Modal, Progress, ActionIcon, Box, createStyles } from '@mantine/core';
import { IconLayoutSidebarLeftExpand } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery, useDisclosure } from '@mantine/hooks';

const useStyles = createStyles((theme) => ({
    modalBody: {
        paddingRight: 0,
        paddingLeft: 0
    },
    progressRoot: {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        borderRadius: '0',
        height: '3px',
        backgroundColor: theme.colors.blue[1]
    },
    progressBar: {
        borderRadius: '0 !important'
    },
    stepLabel: {
        background: theme.colors.blue[0],
        color: theme.colors.blue[6],
        padding: '0.5rem',
        margin: '-0.5rem'
    }
}));

export type FormStepperWrapperHandle = {
    closeModal: () => void;
};
export type FormStepperWrapperProps = {
    children: React.ReactNode;
    label: React.ReactNode;
    currentStep: number;
    totalSteps: number;
};

export const FormStepperWrapper = React.forwardRef<FormStepperWrapperHandle, FormStepperWrapperProps>(
    ({ children, label, currentStep, totalSteps }, ref) => {
        const { classes } = useStyles();
        const matches = useMediaQuery('(min-width: 768px)');
        const [opened, { open, close }] = useDisclosure(false);

        React.useImperativeHandle(
            ref,
            () => ({
                closeModal: () => {
                    return close();
                }
            }),
            [close]
        );

        return !matches ? (
            <Box className={classes.stepLabel}>
                <Modal
                    opened={opened}
                    onClose={close}
                    title="Form Navigation"
                    centered
                    classNames={{
                        body: classes.modalBody
                    }}
                >
                    {children}
                </Modal>
                <Progress
                    value={currentStep * (100 / totalSteps)}
                    classNames={{
                        root: classes.progressRoot,
                        bar: classes.progressBar
                    }}
                />
                <Group position="apart" style={{ marginBottom: '3px' }}>
                    {label}
                    <ActionIcon color="blue" variant="light" onClick={open}>
                        <IconLayoutSidebarLeftExpand size={14} />
                    </ActionIcon>
                </Group>
            </Box>
        ) : (
            <>{children}</>
        );
    }
);
